<div class="header">
    <div class="header-cont">
        <h2>{{theme_current.name[current_lang]}}</h2>
        <button mat-raised-button class="page-header-btns remove-element" (click)="elemDelete()">
          <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>

<div class="section-headers">
    <div class="section-headers-cont">
        <h4>{{ 'admin_single_theme.sections.name' | translate }}</h4>
    </div>
</div>

<div class="single-section">
    <div class="section-cont">
        <mat-tab-group>
            <mat-tab label="Italiano">
                <mat-form-field class="section-input">
                    <mat-label>{{ 'admin_single_theme.sections.name' | translate }}</mat-label>
                    <input matInput type="text" required [(ngModel)]="theme_current.name['it']">
                </mat-form-field>
            </mat-tab>
            <mat-tab label="Slovenščina">
                <mat-form-field class="section-input">
                    <mat-label>{{ 'admin_single_theme.sections.name' | translate }}</mat-label>
                    <input matInput type="text" required [(ngModel)]="theme_current.name['sl']">
                </mat-form-field>
            </mat-tab>
            <mat-tab label="English">
                <mat-form-field class="section-input">
                    <mat-label>{{ 'admin_single_theme.sections.name' | translate }}</mat-label>
                    <input matInput type="text" required [(ngModel)]="theme_current.name['en']">
                </mat-form-field>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<div class="page-footer">
    <div class="page-footer-btns">
        <button mat-raised-button class="save-icon-btn" (click)="saveTheme()" [disabled]="saveButtonDisabled()">
            <mat-icon>save</mat-icon>
        </button>
    </div>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
